import { useTranslation } from 'react-i18next'
import * as z from 'zod'

export const useCommonSchema = () => {
  const { t } = useTranslation()

  const firstName = z
    .string()
    .min(2, t('api:validationErrors.minimumTwoCharacters'))
  const lastName = z
    .string()
    .min(2, t('api:validationErrors.minimumTwoCharacters'))

  // Regex to detect emojis
  const emojiRegex = /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/u
  // Regex to detect invalid symbols
  const invalidSymbolsRegex = /[@#+]/

  const username = z
    .string()
    .min(4, t('api:validationErrors.minimumFourCharacters'))
    .refine((val) => !emojiRegex.test(val), {
      message:
        t('api:validationErrors.usernameNoEmojis') ||
        'Username cannot contain emojis',
    })
    .refine((val) => !invalidSymbolsRegex.test(val), {
      message:
        t('api:validationErrors.usernameInvalidSymbols') ||
        'Username cannot contain @, #, or + symbols',
    })

  const email = z
    .string()
    .email(t('api:validationErrors.invalidEmail'))
    .min(1, t('form:required'))

  return {
    firstName,
    lastName,
    username,
    email,
  }
}
